<template>
  <div class="">
    <v-header :inputName='Name'></v-header>
    <div class="manpin">
      <div class="miansdas">
        <!-- <img src="../../assets/img/topxiang.jpg"> -->
        <!-- <span>你好, {{userInfo.userName}}</span> -->
      </div>
      <v-massage ref="massage" style="width: 1280px;padding-top: 0;"></v-massage>
      <div class="main centen container">
        <div class="main_l">
          <jibenxinxi></jibenxinxi>
        </div>
        <!-- 在class为main_r里面写页面就行 -->
        <div class="main_r">
          <div class="mainr_top">
            <img src="../../assets/gerenzhongxin/geren16.png">
            志愿填报
          </div>
          <div class="tiaobaodan">
            <div class="tiaobaodan_index1 tong" @click="tongyizge(0)">
              <span>院校填报</span>
              <label>按院校进行优先填报</label>
              <div class="annn1">
                立即前往
              </div>
            </div>
            <div class="tiaobaodan_index2 tong" @click="tongyizge(1)">
              <span>专业填报</span>
              <label>按专业进行优先填报</label>
              <div class="annn2">
                立即前往
              </div>
            </div>
            <div class="tiaobaodan_index3 tong" @click="tongyizge(2)" v-if="tianbaoType!=0">
              <span>智能填报</span>
              <label>一键进行智能填报</label>
              <div class="annn3">
                立即前往
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <item7></item7>
    <zuoxuanfu1></zuoxuanfu1>
  </div>
</template>

<script>
  import vHeader from "../../components/vHeader.vue";
  import item7 from "../../components/item7.vue";
  import zuoxuanfu1 from '../../components/zuoxuanfu1.vue'
  import jibenxinxi from '../../components/jibenxinxi.vue'
   import vMassage from "../../components/vMassage.vue";
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      zuoxuanfu1,
      jibenxinxi,
      vMassage
    },
    data() {
      return {
        // 导航选中
        Name: 4,
        userInfo: this.$utils.getlocalStorage('userInfo'),
        tianbaoType: this.$utils.getlocalStorage('tianbaoType'),
      }
    },
    methods: {

      // 院校填报或专业填报
      tongyizge(bog) {
        // this.$router.push('/tiaobaozhiyuan?bog='+bog)
        if (this.$utils.tologin(this)) {
          if (this.$utils.getUserInfo(this)) {
            if(this.$utils.getPhoneStatus(this)){
             if (this.$utils.getFenshu(this)) {
               this.$router.push({
                 path: '/tiaobaozhiyuan',
                 query: {
                   bog: bog
                 }
               });
             }
            }
          }
        }
      },
      // 一键填报
      yijian() {
        this.$router.push('/yijiantianbao')
      }
    },
    created() {
		this.$utils.removelocalStorage("userZhiYuanBatch")
	}


  }
</script>

<style scoped>
  /* 新 */
  .miansdas {
    margin-bottom: 0px;
    width: 100%;
    height: 85px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: url(../../assets/img/beibeiebei.png)no-repeat;
    background-size: 100% 100%;
  }

  .miansdas img {
    width: 90px;
    height: 90px;
    border-radius: 50%;
  }

  .miansdas span {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
  }

  .tiaobaodan {
    width: 999px;
    height: auto;
    display: flex;
    justify-content: space-around;
    padding-top: 40px;
    box-sizing: border-box;
    flex-wrap: wrap;
  }

  .tiaobaodan_index1 {
    cursor: pointer;
    position: relative;
    background: url(../../assets/img/img1-56.png)no-repeat;
    background-size: 100% 100%;
    margin-bottom: 20px;
    width: 300px;
    height: 150px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
  }

  .tiaobaodan_index2 {
    cursor: pointer;
    position: relative;
    background: url(../../assets/img/img2-56.png)no-repeat;
    background-size: 100% 100%;
    margin-bottom: 20px;
    width: 336px;
    height: 150px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
  }

  .tiaobaodan_index3 {
    cursor: pointer;
    position: relative;
    background: url(../../assets/img/img3-56.png)no-repeat;
    background-size: 100% 100%;
    margin-bottom: 20px;
    width: 336px;
    height: 150px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
  }

  .annn1 {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 41px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annn2 {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 41px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annn3 {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #B16800;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 41px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .tong {
    padding-left: 20px;
  }

  .tiaobaodan_index1 span {
    font-size: 28px;
    font-family: GEETYPE-WaonProGB-Flash H;
    font-weight: 400;
    color: #7C504F;
    line-height: 50px;
    margin-top: 10px;
  }

  .tiaobaodan_index2 span {
    font-size: 28px;
    font-family: GEETYPE-WaonProGB-Flash H;
    font-weight: 400;
    color: #566181;
    margin-top: 10px;
  }

  .tiaobaodan_index3 span {
    font-size: 28px;
    font-family: GEETYPE-WaonProGB-Flash H;
    font-weight: 400;
    color: #7A5C31;
    margin-top: 10px;
  }

  .tiaobaodan_index1 label {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #7C504F;
    line-height: 35px;
  }

  .tiaobaodan_index2 label {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #566181;
    line-height: 35px;
  }

  .tiaobaodan_index3 label {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #7A5C31;
    line-height: 35px;
  }


  /* 新 */

  .beijngsd {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    background: url(../../assets/gerenzhongxin/geren21.png)no-repeat;
    background-size: 100% 100%;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .beijngsd span {
    display: flex;
    width: 44px;
    height: 2px;
    opacity: 0.48;
    border-radius: 1px;
    background-color: #FFFFFF;
  }

  .beijngsd span:nth-of-type(1) {
    margin-right: 14px;
  }

  .beijngsd span:nth-of-type(2) {
    margin-left: 14px;
  }

  .centen {
    width: 1280px;
    margin: 0 auto;
    margin-top: 20px;
  }

  .manpin {
    width: 100%;
    height: auto;
    padding-top: 70px;
    /* padding: 40px 0; */
    box-sizing: border-box;
    background: #EBE9E9;
  }

  .main {
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
    background: #EBE9E9;
  }

  .main_l {
    /* background: rgba(251, 251, 251, 1); */
    width: 210px;
  }

  .topxiang {
    width: 100%;
    height: 194px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    margin-bottom: 30px;
  }

  .topxiang img {
    width: 102.73px;
    height: 102.73px;
    margin-bottom: 20px;
  }

  .topxiang span {
    width: 144px;
    height: 22px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    opacity: 1;
  }


  .beijngsdtu {
    background: url(../../assets/gerenzhongxin/geren26.png)no-repeat;
    background-size: 100% 100%;
  }

  .texts {
    color: #F53824 !important;
  }


  .main_r {
    width: 1190px;
    height: 580px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 20px;
    margin-left: 20px;
    box-sizing: border-box;
  }

  .mainr_top {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .mainr_top img {
    width: 7px;
    height: 24px;
    margin-right: 10px;
  }

  .youxinxi {
    padding: 33px 20px 0 20px;
    width: 310px;
    height: 230px;
    background: rgba(253, 251, 247, 1);
    border: 1px solid #FBF5E9;
    opacity: 1;
    border-radius: 5px;
    position: absolute;
    top: 24px;
    right: 20px;
  }

  .mainr_bot {
    width: 100%;
    position: relative;
  }

  .youxinxi label {
    position: absolute;
    top: -14px;
    left: 20px;
    width: 92px;
    height: 28px;
    background: rgba(244, 166, 65, 1);
    opacity: 1;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .youxinxi figure {
    display: flex;
    margin-bottom: 13px;
  }

  .youxinxi figure img {
    margin-right: 4px;
    width: 18px;
    height: 20px;
  }

  .youxinxi figure figcaption {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #5A4F40;
  }

  .form {
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    margin-left: 40px;
  }

  .form li {
    width: auto;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
  }

  .form li label {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    width: 80px;
    text-align: right;
  }

  .form li i {
    color: #F53824;
    margin: 0 5px;
  }

  .form li input {
    width: 372px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #E0E0E0;
    opacity: 1;
    border-radius: 5px;
    padding: 0 10px;
    box-sizing: border-box;

  }

  .duanxin {
    border: none;
    position: absolute;
    top: 5px;
    left: 240px;
    width: 120px;
    height: 30px;
    background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .shoujiinp {
    width: auto;
    display: flex;
    position: relative;
  }

  .form li {
    position: static;
  }

  /* .form li .shoujiinp input{width: auto;} */
  .form li .shoujiinp span {
    margin-top: 5px;
  }

  .form li span {
    margin-left: 5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
    opacity: 1;
  }

  .inps {
    width: 118px;
    height: 40px;
  }

  .inps:nth-of-type(1) {
    margin-right: 9px;
  }

  .inps:nth-of-type(2) {
    margin-right: 9px;
  }

  .inpda {
    width: 372px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    opacity: 1;
  }

  .baochuan {
    border: none;
    margin-left: 115px;
    margin-top: 20px;
    width: 140px;
    height: 46px;
    background: linear-gradient(92deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  @media (max-width:1400px) {
    .centen {
      /* width: auto; */
    }
  }

  @media (min-width:750px) {
    .mainr_bot2 {
      display: none;
    }
  }

  @media (max-width:750px) {
    .miansdas {
      height: 100px;
      margin-bottom: 10px;
    }

    .miansdas img {
      width: 50px;
      height: 50px;
    }

    .miansdas span {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
    }


    .mainr_bot {
      display: none;
    }

    .beijngsd {
      height: 70px;
      font-size: 24px;
    }

    .main {
      flex-direction: column;
    }

    .main_l {
      width: 100%;
    }

    .jibenxinxi::-webkit-scrollbar {
      display: none;
    }

    .manpin {}

    .topxiang {
      flex-direction: row;
      width: 100%;
      height: auto;
      justify-content: revert;
      margin-bottom: 15px;
    }

    .topxiang span {
      margin-left: 20px;
    }

    .topxiang img {
      margin: 0;
      height: 60px;
      width: 60px;
    }

    .jibenxinxi {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: row;
      overflow-y: hidden;
      overflow: auto;
      background: whitesmoke;
    }

    .jibenxinxi figure {
      flex-shrink: 0;
      width: auto;
      margin: 0 5px;
    }

    .beijngsdtu {
      /* background: url(../../assets/gerenzhongxin/sj_geren26.png)no-repeat; */
      background: none;
      /* background-size: 100% 100%; */
      border-bottom: 1px solid #F53824;
    }

    .jibenxinxi figure img {
      margin-left: 0;
    }

    .youxinxi2 {
      padding: 33px 20px 0 20px;
      width: 100%;
      height: 230px;
      background: rgba(253, 251, 247, 1);
      border: 1px solid #FBF5E9;
      opacity: 1;
      border-radius: 5px;
      position: relative;
    }

    .mainr_bot2 {
      width: 100%;
      margin-top: 20px;
      /* position: relative; */
    }

    .youxinxi2 label {
      position: absolute;
      top: -14px;
      left: 20px;
      width: 92px;
      height: 28px;
      background: rgba(244, 166, 65, 1);
      opacity: 1;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }

    .youxinxi2 figure {
      display: flex;
      margin-bottom: 13px;
    }

    .youxinxi2 figure img {
      margin-right: 4px;
      width: 18px;
      height: 20px;
    }

    .youxinxi2 figure figcaption {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #5A4F40;
    }

    .main_r {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      margin-left: 0;
    }


    .form {
      margin-left: 0;
    }

    .shoujiinp {
      flex: 1;
      display: flex;
      flex-direction: column;
      position: relative;
    }

    .form li {
      position: static;
    }

    .form li .shoujiinp input {
      width: auto;
    }

    .form li .shoujiinp span {
      margin-top: 5px;
    }

    .form li label {
      flex-shrink: 0;
    }

    .duanxin {
      right: 10px;
      left: auto;
      top: 5px;
      width: 85px;
      border-radius: 5px;
      font-size: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/tianbao/xuanzheyuanhuoye.vue